export { default as InstagramIcon } from "./InstagramIcon";
export { default as LinkedinIcon } from "./LinkedinIcon";
export { default as TelegramIcon } from "./TelegramIcon";
export { default as DefaultIcon } from "./DefaultIcon";
export { default as SearchIcon } from "./SearchIcon";
export { default as CalendarIcon } from "./CalendarIcon";
export { default as TimeIcon } from "./TimeIcon";
export { default as ArrowLeft } from "./ArrowLeft";
export { default as ArrowRight } from "./ArrowRight";
export { default as PinIcon } from "./PinIcon";
export { default as EnvelBoxIcon } from "./EnvelBoxIcon";
export { default as EnvelopeIcon } from "./EnvelopeIcon";
export { default as PhoneCallIcon } from "./PhoneCallIcon";
export { default as FaxIcon } from "./FaxIcon";
export { default as LDPolyIcon } from "./LDPolyIcon";
export { default as MDPolyIcon } from "./MDPolyIcon";
export { default as HDPolyIcon } from "./HDPolyIcon";
export { default as OliPolyIcon } from "./OliPolyIcon";

export { default as ComAtGIcon } from "./ComAtGIcon";
export { default as HistoryIcon } from "./HistoryIcon";
export { default as ManageHisIcon } from "./ManageHisIcon";
export { default as EyeIcon } from "./EyeIcon";
export { default as StrengthIcon } from "./StrengthIcon";
export { default as DesclamerIcon } from "./DesclamerIcon";
export { default as GlocationIcon } from "./GlocationIcon";
export { default as CertificatesIcon } from "./CertificatesIcon";

export { default as HdpeIcon } from "./HdpeIcon";
export { default as LdpeIcon } from "./LdpeIcon";
export { default as MdpeIcon } from "./MdpeIcon";
export { default as OlefinIcon } from "./OlefinIcon";
export { default as ProductsIcon } from "./ProductsIcon";
export { default as CatalogueIcon } from "./CatalogueIcon";
export { default as InformationIcon } from "./InformationIcon";
export { default as StorageIcon } from "./StorageIcon";
export { default as QualityIcon } from "./QualityIcon";
export { default as QualificationIcon } from "./QualificationIcon";

export { default as OccupationalIcon } from "./OccupationalIcon";
export { default as EnvironmentIcon } from "./EnvironmentIcon";
export { default as PersonalSafetyIcon } from "./PersonalSafetyIcon";
export { default as ProcessSafetyIcon } from "./ProcessSafetyIcon";
export { default as BehavioralSafetyIcon } from "./BehavioralSafetyIcon";
export { default as HseTrainingIcon } from "./HseTrainingIcon";
export { default as ResponsibilityIcon } from "./ResponsibilityIcon";
export { default as EmergencyIcon } from "./EmergencyIcon";

export { default as IocalIcon } from "./IocalIcon";
export { default as ExportIcon } from "./ExportIcon";
export { default as FormBourseIcon } from "./FormBourseIcon";
export { default as FormCplusIcon } from "./FormCplusIcon";
export { default as FormETIcon } from "./FormETIcon";
export { default as FormSuggesIcon } from "./FormSuggesIcon";
export { default as FormComplaintIcon } from "./FormComplaintIcon";
export { default as FormPreSub } from "./FormPreSub";
export { default as AbsorpProIcon } from "./AbsorpProIcon";
export { default as FormSupplierEvalIcon } from "./FormSupplierEvalIcon";
export { default as TendersIcon } from "./TendersIcon";

export { default as HrManagePIcon } from "./HrManagePIcon";
export { default as HumanResoManageIcon } from "./HumanResoManageIcon";
export { default as CodeEthicsIcon } from "./CodeEthicsIcon";
export { default as JobPositionsIcon } from "./JobPositionsIcon";
export { default as FormJobRegIcon } from "./FormJobRegIcon";
export { default as AbsorProcIcon } from "./AbsorProcIcon";
export { default as ServicesIcon } from "./ServicesIcon";

export { default as MediaNewsIcon } from "./MediaNewsIcon";
export { default as MediaGalleryIcon } from "./MediaGalleryIcon";

export { default as CustomersIcon } from "./CustomersIcon";
export { default as SuppliersIcon } from "./SuppliersIcon";
export { default as JobseekersIcon } from "./JobseekersIcon";
export { default as ShareholdersIcon } from "./ShareholdersIcon";

export { default as BelievingEnvIcon } from "./BelievingEnvIcon";
export { default as EffectivenessIcon } from "./EffectivenessIcon";
export { default as RespectEmployeesIcon } from "./RespectEmployeesIcon";
export { default as IntegrityIcon } from "./IntegrityIcon";
export { default as CheckList } from "./CheckList";
export { default as FocusingSocialIcon } from "./FocusingSocialIcon";
export { default as SustainableQualityIcon } from "./SustainableQualityIcon";

export { default as BriefCaseFullIcon } from "./BriefCaseFullIcon";
export { default as PaperIcon } from "./PaperIcon";
export { default as AnnoncementIcon } from "./AnnoncementIcon";

export { default as ResumeIcon } from "./ResumeIcon";
export { default as ChecklistIcon } from "./ChecklistIcon";
export { default as PhoneIntIcon } from "./PhoneIntIcon";
export { default as InterviewIcon } from "./InterviewIcon";
export { default as PcycologyIcon } from "./PcycologyIcon";
export { default as AcceptIcon } from "./AcceptIcon";
export { default as BriefCase } from "./BriefCase";
export { default as SocietyIcon } from "./SocietyIcon";

export { default as InfrastructureIcon } from "./InfrastructureIcon";
export { default as ApplicationIcon } from "./ApplicationIcon";
export { default as SupportIcon } from "./SupportIcon";
export { default as RiskIcon } from "./RiskIcon";
export { default as SterategicIcon } from "./SterategicIcon";

export { default as SuccessIcon } from "./SuccessIcon";
export { default as DownLoadIcon } from "./DownLoadIcon";
export { default as CloseIcon } from "./CloseIcon";
